import './App.css';
import Navbar from './Utility/UtilHeader/UtilHeader';
import { BrowserRouter , Routes, Route } from 'react-router-dom';
import SidebarWithContent from './Pages/documentPage/documentPage';
import Footer from './Utility/UtilFooter/UtilFooter';
import { Box } from '@mui/material';
import BusinessToolsCards from './Utility/UtilCategoryCard/UtilCategoryCard';
import ArticlePage from './Pages/articlePage/ArticlePage';
import ScrollToTop from './Components/ScrollToTop';
console.log = () => {}
console.error = () => {} 
function App() {
  return (
    <BrowserRouter>
      <div>
        <Navbar />
           <ScrollToTop />
        <Routes>
          <Route path="/knowledgebase/" element={<BusinessToolsCards/>} />
          <Route path="/knowledgebase/article/:search/:id" element={<ArticlePage/>}/>
          <Route path="/knowledgebase/document/:recordid" element={<SidebarWithContent />} />
        </Routes>
      </div>
        <Box>
        <Footer/>
      </Box>
    </BrowserRouter>
  );
}
export default App